// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"7ded871c","139":"9cd0f40f","239":"a028f5c5","453":"acffe1ea","455":"2f5866cf","511":"d67cc4be","977":"362b59f0"}[chunkId] + ".chunk.js";
};